import moment from 'moment';

class DateTimeHelper {
    static convertDateToISO8601String(date) {
        const m = moment.utc(date);

        if (m.isValid()) {
            return m.format('YYYY-MM-DD[T]HH:mm:ss[Z]');
        } else {
            return null;
        }
    }

    // not only accept ISO 8601 string, but ISO 8601 string is recommended
    // reference: https://momentjs.com/docs/#/parsing/string/
    static convertISO8601StringToDate(iso8601String) {
        const m = moment(iso8601String);

        if (m.isValid()) {
            return m.toDate();
        } else {
            return null;
        }
    }
}

export default DateTimeHelper;
